import React, { useState } from 'react';
import {
	ModalContainer,
	Paragraph,
	tokens,
	Radio,
	Label,
} from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';
import {
	Container,
	ButtonContainer,
	RadioContainer,
} from './ModalLinkEmployees.styles';
import { ReactComponent as UserAdd } from 'App/assets/img/candidate.svg';

type ModalLinkEmployeesProps = {
	onConfirm: (linkEmployeesKind: string) => void;
	onClose: () => void;
};

export const ModalLinkEmployees = ({
	onConfirm,
	onClose,
}: ModalLinkEmployeesProps) => {
	const [linkEmployeesKind, setLinkEmployeesKind] = useState<'csv' | 'manual'>(
		'manual',
	);

	return (
		<ModalContainer
			visible
			width="420px"
			height="320px"
			closeOnlyOnTheButton
			headerIcon={<UserAdd />}
		>
			<Container>
				<Paragraph
					textAlign="center"
					padding="0px 25px 20px 20px"
					fontSize="16px"
					fontWeight="600"
				>
					Vincular colaboradores
				</Paragraph>
				<RadioContainer>
					<Radio
						name="manualLink"
						value="true"
						size="small"
						onChange={() => setLinkEmployeesKind('manual')}
						checked={linkEmployeesKind === 'manual'}
					/>
					<Label fontWeight={600} fontSize={14} margin="0">
						Seleccionar colaboradores
					</Label>
				</RadioContainer>
				<RadioContainer>
					<Radio
						name="csvLink"
						value="true"
						size="small"
						onChange={() => setLinkEmployeesKind('csv')}
						checked={linkEmployeesKind === 'csv'}
					/>
					<Label fontWeight={600} fontSize={14} margin="0">
						Subir CSV
					</Label>
				</RadioContainer>
				<ButtonContainer>
					<Button onClick={() => onConfirm(linkEmployeesKind)} width="150px">
						Confirmar
					</Button>
					<a onClick={onClose}>
						<Paragraph
							color={tokens.color_primary}
							textAlign="center"
							cursor={'pointer'}
							fontWeight="500"
						>
							Cancelar
						</Paragraph>
					</a>
				</ButtonContainer>
			</Container>
		</ModalContainer>
	);
};
